module.exports = __webpack_public_path__ + "assets/img/close.2e5ad585.svg";